module.exports = __webpack_public_path__ + "img/19.d69aea1f.jpg";